module.exports = __webpack_public_path__ + "img/check-white.1054b9fb.svg";